import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';
import ModelsHeader from '../components/models/ModelsHeader';
import ModelsList from '../components/models/ModelsList';
import ModelsPagination from '../components/models/ModelsPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageNavigateTitle from '../components/shared/page/PageNavigateTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import useFetchModelsBrand from '../hooks/models/useFetchModelsBrand';

const Models = () => {
  const { brandId } = useParams();
  const { brand, loading } = useFetchModelsBrand(brandId);

  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));

  return (
    <Suspense fallback={<CommonLoader />}>
      {loading ? (
        <CommonLoader />
      ) : (
        <section>
          <PageTitleContainer>
            <PageNavigateTitle title={`Моделі марки ${brand.name}`} link={'/brands'} />
          </PageTitleContainer>
          <Container>
            <ModelsHeader readOnly={readOnly} />
            <ModelsList readOnly={readOnly} />
            <ModelsPagination />
          </Container>
        </section>
      )}
    </Suspense>
  );
};

export default Models;
